<table
  matSort
  mat-table
  multiTemplateDataRows
  [dataSource]="machines"
  (matSortChange)="sortData($event)"
  class="fc-machines-table"
>
  <ng-container
    matColumnDef="{{ column }}"
    *ngFor="let column of columnsToDisplay"
  >
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header="{{ column }}"
      [disabled]="column === '#'"
      class="fc-th"
    >
      <span class="fc-th-label" *ngIf="column !== 'power' && column !== '#'">
        {{ columnsHeadLabels.get(column) ? columnsHeadLabels.get(column) : column }}
      </span>
      <span class="fc-th-label fc-th-label--energy" *ngIf="column === 'power'">
        {{ columnsHeadLabels.get(column) ? columnsHeadLabels.get(column) : column }}
        <mat-icon class="fc-energy-icon" inline>bolt</mat-icon>
      </span>
    </th>

    <td mat-cell *matCellDef="let element" class="fc-td">

      <!-- State column: pill badge -->
      <ng-container *ngIf="column === 'state'">
        <span class="fc-badge fc-badge--run fc-badge--pulse" *ngIf="element[column] === 'RUN'">
          <span class="fc-dot"></span>Running
        </span>
        <span class="fc-badge fc-badge--stop" *ngIf="element[column] === 'STOP'">
          <span class="fc-dot"></span>Stopped
        </span>
        <span class="fc-badge fc-badge--err fc-badge--pulse" *ngIf="element[column] === 'ERR'">
          <span class="fc-dot"></span>Error
        </span>
        <span class="fc-badge fc-badge--off" *ngIf="element[column] === 'OFF'">
          <span class="fc-dot"></span>Offline
        </span>
      </ng-container>

      <!-- Power column -->
      <ng-container *ngIf="column === 'power'">
        <span class="fc-power-wrap">
          <mat-icon
            class="fc-algo-icon"
            matTooltip="Energy consumption value computed on a statistical basis"
            *ngIf="element['powerAlgorithm'] === 'STATISTICAL_METHOD'"
          >insights</mat-icon>
          <mat-icon
            class="fc-algo-icon"
            matTooltip="Energy computed consumption value through real data"
            *ngIf="element['powerAlgorithm'] === 'POLLING_DETECTION'"
          >troubleshoot</mat-icon>
          <span class="fc-power-value" *ngIf="element[column] !== undefined">
            {{ element[column] | number:'1.2-2' }}
          </span>
        </span>
      </ng-container>

      <!-- Expand toggle column -->
      <ng-container *ngIf="column === '#'">
        <span class="material-icons fc-expand-icon">
          {{ element !== expandedElement ? 'expand_more' : 'expand_less' }}
        </span>
      </ng-container>

      <!-- All other columns -->
      <ng-container *ngIf="column !== 'state' && column !== 'power' && column !== '#'">
        <span
          class="fc-cell-text"
          [class.fc-cell-name]="column === 'name'"
          [class.fc-cell-desc]="column === 'stateDescription'"
          [class.fc-cell-desc--err]="column === 'stateDescription' && element['state'] === 'ERR'"
          *ngIf="element[column]"
        >{{ element[column] }}</span>
      </ng-container>

    </td>
  </ng-container>

  <!-- Expanded detail row -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="columnsToDisplay.length"
      class="fc-detail-td"
    >
      <div
        class="fc-detail-wrapper"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="fc-detail">
          <div *ngIf="element.state" class="fc-detail-state" [ngSwitch]="element.state">
            <span class="fc-detail-label">State:</span>
            <span *ngSwitchCase="'OFF'" class="fc-detail-value">Machine is off</span>
            <span *ngSwitchCase="'RUN'" class="fc-detail-value fc-detail-value--run">Machine is working</span>
            <span *ngSwitchCase="'ERR'" class="fc-detail-value fc-detail-value--err">Machine is in error</span>
            <span *ngSwitchCase="'STOP'" class="fc-detail-value">Machine is on but not working</span>
            &nbsp;&nbsp;
            <span class="fc-detail-label">Current work:</span>
            <span class="fc-detail-value fc-mono"> {{ element.stateDescription }}</span>
          </div>
          <app-machine-daily-works [machineId]="element.id"></app-machine-daily-works>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplay"
    class="fc-row"
    [class.fc-row--expanded]="element === expandedElement"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="fc-detail-row"
  ></tr>
</table>
